/**
 * Copyright 2025 Lumavec Group LLC
 *
 * Revert confirmation dialog component
 */

import React from 'react';
import { Undo, Loader } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';

interface RevertDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  revertAll: boolean;
  selectedFilesCount: number;
  onRevert: () => void;
  reverting: boolean;
}

export function RevertDialog({
  isOpen,
  onOpenChange,
  revertAll,
  selectedFilesCount,
  onRevert,
  reverting
}: RevertDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Revert Changes</AlertDialogTitle>
          <AlertDialogDescription>
            {revertAll
              ? 'This will revert ALL changes in this worktree. This action cannot be undone.'
              : `This will revert ${selectedFilesCount} selected file(s). This action cannot be undone.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        <AlertDialogFooter>
          <AlertDialogCancel disabled={reverting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onRevert();
            }}
            disabled={reverting}
            className="bg-red-600 hover:bg-red-700"
          >
            {reverting ? (
              <>
                <Loader size={14} className="animate-spin mr-2" />
                Reverting...
              </>
            ) : (
              <>
                <Undo size={14} className="mr-2" />
                Revert
              </>
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

